import { media, styled } from '@pulse-web-ui/theme';

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${media.desktopLarge} {
    display: grid;
    grid-template-columns: minmax(300px, 768px) 324px;
    grid-template-rows: 45px 1fr;
    column-gap: 16px;
    row-gap: 0;
  }
`;

export const LeftCol = styled.div`
  ${media.desktopLarge} {
    grid-row: 1 / 3;
    grid-column: 1 / 2;
  }
`;

export const SummaryCol = styled.div`
  ${media.desktopLarge} {
    grid-row: 2;
    grid-column: 2;
  }
`;
